import React from 'react';
import { Typography } from '../Typography';
import './InsuranceVerificationDetails.scss';

interface InsuranceVerificationHeaderProps {
  title?: string;
  description?: string;
}

export const InsuranceVerificationHeader: React.FC<
  InsuranceVerificationHeaderProps
> = ({ title, description }) => (
  <div className="header-section">
    {title && (
      <Typography variant="size-26" color="color-31">
        {title}
      </Typography>
    )}
    {description && (
      <Typography
        variant="size-16"
        color="color-2"
        className="mt-3"
        dangerouslySetInnerHTML={{ __html: description ?? '' }}
       />
    )}
  </div>
);
